export const removeFromFavoritesCategoryText = "a_XBgd";
export const removeFromFavoritesCategoryTextTeams = "si9wUd";
export default {removeFromFavoritesCategoryText,removeFromFavoritesCategoryTextTeams};